const getIndicativeColourWayId = ({ selectedColourWayId = null }) =>
  selectedColourWayId === null ? null : { colourWayId: selectedColourWayId };

export default getIndicativeColourWayId;
